import React from 'react';
import PropTypes from 'prop-types';
import { isFinite } from 'lodash';

import { LocaleService } from '@sm360/widget-commons-core-services';

import TaxSavings from 'trade-in/components/EstimateTradeIn/components/TaxSavings/TaxSavings.jsx';
import DealerLogo from 'trade-in/components/EstimateTradeIn/DealerLogo.jsx';
import EstimateSlider from 'trade-in/components/EstimateTradeIn/EstimateSlider.jsx';
import 'trade-in/components/EstimateTradeIn/EstimateTradeIn.scss';

const EstimateTradeIn = ({ tradeInValues, handleRangeChange, handleEstimateChange }) => {
    const isValidTradeInValue = isFinite(tradeInValues.amount) && tradeInValues.amount > 0;
    const isValidTradeInValueMax = isFinite(tradeInValues.high) && tradeInValues.high > 0;
    const isValidTradeInValueMin = isFinite(tradeInValues.low) && tradeInValues.low > 0;

    if (!isValidTradeInValueMin || !isValidTradeInValueMax || !isValidTradeInValue) {
        return (
            <div className="estimate__content">
                <h3 className="sr-subtitle-2 is-centered">
                    <icon className="icon-Warning is-warning" /> {LocaleService.t('TRADE_IN.ESTIMATE.ERROR.TITLE')}
                </h3>
                <p>{LocaleService.t('TRADE_IN.ESTIMATE.ERROR.TEXT')}</p>
            </div>
        );
    }

    return (
        <div className="estimate__content">
            <DealerLogo />
            <h3 className="sr-subtitle-2 is-centered">{LocaleService.t('TRADE_IN.ESTIMATE.TITLE')}</h3>
            <EstimateSlider
                tradeInValues={tradeInValues}
                handleRangeChange={handleRangeChange}
                handleEstimateChange={handleEstimateChange}
            />
            <TaxSavings tradeInValues={tradeInValues} />
        </div>
    );
};

EstimateTradeIn.propTypes = {
    tradeInValues: PropTypes.shape({
        amount: PropTypes.number.isRequired,
        high: PropTypes.number.isRequired,
        low: PropTypes.number.isRequired,
        taxesFactor: PropTypes.number.isRequired,
    }).isRequired,
    handleRangeChange: PropTypes.func.isRequired,
    handleEstimateChange: PropTypes.func.isRequired,
};

EstimateTradeIn.displayName = 'EstimateTradeIn';

export default EstimateTradeIn;



// WEBPACK FOOTER //
// ./src/components/EstimateTradeIn/EstimateTradeIn.jsx